module.exports = __webpack_public_path__ + "static/img/indicator_light02.a1349f8.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/bird/indicator_light02.gif
// module id = DW2Y
// module chunks = 1